/* istanbul ignore file */

import { getResizedImageUrl } from '@lib/image';

export default getResizedImageUrl;
